module.exports = __webpack_public_path__ + "img/startup_demo_day_logo_720.617c34d4.png";